import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';

import { auth } from 'src/services/firebase-service';
import logging from 'src/services/logging';
import { signOut } from 'firebase/auth';

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  Typography,
} from '@mui/material';

const LogoutPage = () => {
  const [user, error] = useAuthState(auth);
  const navigate = useNavigate();

  if (error) {
    logging.error(error, 'LogoutPage');
  }

  const logout = async () => {
    try {
      if (user) {
        await signOut(auth);
        logging.info(
          `${user.displayName} succesfully logged out.`,
          'LogoutPage'
        );
        navigate('/');
      }
    } catch (error: any) {
      logging.error(error, 'LogoutPage');
    }
  };

  return (
    <Container maxWidth='sm'>
      <Card>
        <CardHeader title='Logout' />
        <Divider />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>Are you sure you want to logout?</Typography>
            </Grid>
            <Grid item>
              <Button
                variant='contained'
                color='error'
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button variant='contained' color='success' onClick={logout}>
                Logout
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};

export default LogoutPage;
